import React, { useReducer } from "react";
import { useParams, useHistory } from "react-router-dom";
import ErrorFooter from "../../components/ErrorFooter/ErrorFooter";
import AddSpocModal from "../../components/AddSpocModal/AddSpocModal";
import { MdFace, MdDoneAll } from "react-icons/md";

import { constants } from "../../constants/";
import { request, handleErrors } from "../../services/helpers";
import LoadingOverlay from "react-loading-overlay";

const SET_MODAL_VISIBLE = "SET_MODAL_VISIBLE";
const SPOC_CREATED = "SPOC_CREATED";
const FORM_SUBMIT_REQUEST = "FORM_SUBMIT_REQUEST";
const FORM_SUBMIT_SUCCESS = "FORM_SUBMIT_SUCCESS";
const FORM_SUBMIT_FAILURE = "FORM_SUBMIT_FAILURE";

const initialState = {
  loading: false,
  modalVisible: false,
  isSpocCreated: false,
  error: "",
  createdUser: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case SET_MODAL_VISIBLE:
      return {
        ...state,
        modalVisible: action.payload,
      };

    case SPOC_CREATED:
      return {
        ...state,
        loading: false,
        isSpocCreated: true,
        createdUser: action.payload,
      };

    case FORM_SUBMIT_REQUEST:
      return {
        ...state,
        modalVisible: false,
        loading: true,
        error: "",
      };

    case FORM_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case FORM_SUBMIT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

const AddSpoc = (props) => {
  const params = useParams();
  const { membershipId, membershipName } = params;
  const history = useHistory();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { modalVisible, isSpocCreated, error, loading, createdUser } = state;

  const onSubmit = async (data) => {
    try {
      dispatch({
        type: FORM_SUBMIT_REQUEST,
      });
      const res = await request.post("/memberships/spoc", {
        name: data.spocName,
        email: data.spocEmail,
        membershipId,
      });
      dispatch({
        type: SPOC_CREATED,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: FORM_SUBMIT_FAILURE,
        payload: handleErrors(e) || e,
      });
    }
  };

  const handleCompleteForm = async (e) => {
    e.preventDefault();
    request.post("/memberships/email", { createdUser });
    history.push("/");
  };

  return (
    <LoadingOverlay
      active={loading}
      spinner={loading}
      text="Loading please wait"
    >
      <div className="flex flex-col justify-evenly h-screen items-center">
        <div>
          <img
            src={
              isSpocCreated
                ? constants.postSpocConfirmation
                : constants.preSpocConfirmation
            }
            alt="pre-tick"
          />
        </div>
        <div className="">
          <div className="text-center">
            <h1 className="font-medium md:text-6xl text-4xl">
              Membership Created
            </h1>
          </div>
          <div className=" text-center">
            <h3 className="text-xl leading-6">Membership Name</h3>
            <h3 className="font-medium text-xl leading-6">{membershipName}</h3>
          </div>
        </div>

        {!isSpocCreated && !createdUser ? (
          <button
            onClick={() => dispatch({ type: SET_MODAL_VISIBLE, payload: true })}
            className="flex justify-between p-5 items-center shadow-lg rounded-lg outline-none hover:opacity-75 w-64"
          >
            <div>
              <MdFace size={24} />
            </div>
            <div>
              <p className="uppercase text-sm leading-4">
                Add a Spoc for Membership
              </p>
            </div>
          </button>
        ) : (
          <>
            <div className="flex p-3 justify-between text-black items-center border border-gray-500 rounded-lg outline-none hover:opacity-75 w-64">
              <div>
                <span className="text-xs">spoc</span>
                <span className="block">{createdUser.name}</span>
              </div>
              <div>
                <MdDoneAll color="green" size={24} />
              </div>
            </div>
          </>
        )}

        {isSpocCreated && (
          <button
            onClick={handleCompleteForm}
            className="bg-themeYellow rounded-md border-gray-500 uppercase px-32 py-4 font-bold text-base leading-4 tracking-widest outline-none"
          >
            complete form
          </button>
        )}

        <AddSpocModal
          membershipName={membershipName}
          onCancel={() => dispatch({ type: SET_MODAL_VISIBLE, payload: false })}
          onSubmit={onSubmit}
          modalProps={{
            open: modalVisible,
            onBackdropClick: () => {
              dispatch({ type: SET_MODAL_VISIBLE, payload: false });
            },
          }}
        />

        {error && (
          <div className="error-footer">
            <ErrorFooter message={error} />
          </div>
        )}
      </div>
    </LoadingOverlay>
  );
};

export default AddSpoc;
